import React from "react"
import { cn } from "@/lib/utils"

interface ProgressNoteReadOnlyCardSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string
  children: React.ReactNode
  testId?: string
  isEditMode?: boolean
}

const ProgressNoteReadOnlyCardSection = ({
  isEditMode = false,
  title,
  children,
  testId,
  className,
}: ProgressNoteReadOnlyCardSectionProps) => {
  return (
    <div
      className={cn(
        "grid p-4",
        isEditMode ? "gap-3.5 pt-2.5" : "grid-cols-[minmax(auto,120px)_minmax(auto,1fr)] gap-4",
        className,
      )}
      data-testid={testId}>
      <span className="text-on-surface-subdued text-sm font-medium" data-testid={`${testId}-title`}>
        {title}
      </span>
      <div className="text-on-surface break-word-legacy text-sm font-normal" data-testid={`${testId}-content`}>
        {children}
      </div>
    </div>
  )
}

export { ProgressNoteReadOnlyCardSection }
